<table class="table table-bordered table_vam" id="soundBtnMediumControls" style="margin-top: 60px; margin-bottom: 30px">
  <thead>
    <tr>
      <th class="col-md-1" style="padding-top: 10px; vertical-align:middle">Call time</th>
      <th class="col-md-1" style="padding-top: 4px; vertical-align:middle">Status</th>
      <th class="col-md-1" style="padding-top: 4px; vertical-align:middle">Duration</th>
      <th class="col-md-5" style="padding-top: 4px; vertical-align:middle" *ngIf="messagesHasRecordings()">Play/Download</th>
      <th class="col-md-5" style="padding-top: 4px; vertical-align:middle" *ngIf="!messagesHasRecordings()">Message Played</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let message of messages">
      <td style="padding-top: 10px; vertical-align:middle">{{message.createdMs | amDateFormat:'MM/DD/YYYY h:mm:ss a'}}</td>
      <td style="padding-top: 10px; vertical-align:middle">{{message.messagePartState !== undefined && message.messagePartState !== null ? message.messagePartState : message.messageState}}</td>
      <td style="padding-top: 10px; vertical-align:middle" *ngIf="message.answeredBy === undefined">{{message.messagePartDuration !== undefined && message.messagePartDuration !== null ? message.messagePartDuration : message.duration}} sec.</td>
      <td style="padding-top: 10px; vertical-align:middle" *ngIf="message.answeredBy !== undefined">{{message.messagePartDuration !== undefined && message.messagePartDuration !== null && message.messagePartDuration !== 0
          ? message.messagePartDuration : message.duration}} sec.</td>
      <td *ngIf="messagesHasRecordings()">
        <table>
          <tr id="centered">
            <td *ngIf="message.audioService.getPlayerStatus() | async as playerStatus">
              <button class="btn btn-default" id="play"
                      style="padding: 0; border-style: none;" (click)="play(message.messageUuid, message.messagePartId, message.audioService);"
                      *ngIf="playerStatus !== 'playing'">

                <i class="glyphicon glyphicon-play"></i>
              </button>
              <button class="btn btn-default" id="stop"
                      style="padding: 0; border-style: none;" (click)="stop(message.audioService);"
                      *ngIf="playerStatus === 'playing'">
                <i class="glyphicon glyphicon-stop"></i>
              </button>
            </td>
            <td>
              <a class="btn btn-default" tooltip="Download voice recording (mp3)"
                 style="padding: 0; border-style: none;"
                 [href]="getDownloadLink(message.messageUuid,  message.messagePartId)"
                 target="hidden-iframe-for-download"
              >
                <i class="glyphicon glyphicon-download"></i>
              </a>
              <iframe name="hidden-iframe-for-download"
                      src="https://www.autoremind.com/"
                      style="visibility: hidden; height: 1px; width: 1px;">
              </iframe>
            </td>
          </tr>
        </table>

      </td>
      <td *ngIf="!messagesHasRecordings()">
            <div class="left bubble-tts" *ngIf="message.playedTts">
              <div style="white-space: pre-wrap; font-family: Helvetica Neue,Helvetica,Arial,sans-serif;
                  font-size: 13px; line-height: 24px;
                  width: 100%; overflow: hidden; overflow-x: auto; outline: none; border: none;
                  box-shadow: none; min-width: 300px;">{{message.playedTts}}</div>
            </div>
        Answered by: {{getAnsweredByText(message.answeredBy)}}<br/>
        Detail: {{message.callReason}}<br/>
      </td>
    </tr>
  </tbody>
</table>